
{
  "home": {
    "groupCompanies": "Company details",
    "contacts": "Contacts",
    "addressBook": "Address book",
    "noResults": "No results",
    "pattern": "Invalid pattern",
    "datePattern": "Dates are displayed in dd/mm/yyyy format",
    "portside":"Portside",
    "bondedWarehouse":"Bonded warehouse",
    "admin":"Others",
    "datePicker": {
      "nextMonth": "Next Month",
      "preMonth": "Previous Month",
      "selectMonth": "Select Month",
      "selectyear": "Select Year"
    },
    "headerLinks": {
      "help": "Help",
      "products": "Materials",
      "material": "Material",
      "myQuotes": "Bids & offers",
      "myContracts": "Contracts",
      "myCompany": "My company",
      "bhpTeam": "BHP team",
      "Ships&Docs": "Ships and Docs",
      "signIn": "Sign in",
      "register": "Register an account",
      "Menu": "Menu",
      "MyCompany": "My Company",
      "GroupCompanies": "Company details",
      "Contacts": "Contacts",
      "Addressbook": "Addressbook",
      "BHPTeam": "BHP Team",
      "ContactUs": "Contact Us",
      "Help": "Help",
      "passwordSent": "Reset password email has been sent!",
      "addressBook": "Address book",
      "inventoryManagement": "Inventory Management",
      "home":"Home",
      "invitationToBid":"Invitation to bid",
      "ships&docs": "Shipment & docs",
      "help&support":"Help & support",
      "bilateralCargos": "Bilateral-Cargos"
    },
    "notifications": {
      "responseRequired": "Response required",
      "awaitingResponse": "Awaiting response from BHP",
      "invitationsToBidAvailable": "Invitations To Bid Available"
    },
    "myAccount": {
      "updatePersonalDetails": "Update personal details",
      "resetPassword": "Reset password",
      "logout": "Logout",
      "signOut": "Sign Out",
      "language": "en",
      "biometric":"Biometrics and security"
    },
    "footer": {
      "contactUs": "Contact us",
      "myAccount": "My account",
      "email": "Email",
      "liveChat": "Live chat",
      "callUs": "+00 000 000",
      "BHPchina": "BHP-China.cn",
      "linkedIn": "LinkediIn"
    },
    "I18N_VALUES": {
      "weekdays": "Mon,Tue,Wed,Thur,Fri,Sat,Sun",
      "months": "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec",
      "weekLabel": "sem"
    },
    "copyright": {
      "accessibility": "Accessibility",
      "privacyPolicy": "Privacy policy",
      "privacy":"Privacy",
      "termsOfUse": "Terms of use",
      "buyerTerms":"Buyer’s Terms of Use",
      "termsOfUsePartner": "Vendor’s Terms of Use",
      "termsOf":"Vendor’s Terms",
      "bhp2021": "© BHP 2021",
      "firstSlotData1": "Shanghai Public Network Security No. ",
      "firstSlotData2": "",
      "secondSlotData1": "Shanghai ICP No. ",
      "secondSlotData2": "",
      "cookiesPolicy": "Cookies Policy",
      "cookies": "Cookies",
      "footerTextBeforeHyperlink": "This invitation to bid, all bidding processes operated through BHP connect and your continued use of BHP connect are governed by the",
      "footerTextAfterHyperlink": "and the relevant Terms and Conditions specified in the invitation to bid"
    },
    "productHeader": {
      "BHPCommercial": "BHP Connect",
      "DigitalGateway": "Digital Gateway",
      "Simplifying": "Simplifying the buying of BHP’s world-class commodities.",
      "Welcome": "Welcome back, ",
      "Filter": "Filter by:",
      "BrowsebyPort": "Browse by place of delivery ",
      "BrowsebyProduct": "Browse by material",
      "BrowseAll": "Browse all",
      "All": "All",
      "SelectPorts": "Select place of delivery ",
      "SelectProductTypes": "Select material types",
      "SelectCommodity": "Select commodity",
      "SelectedCommodity": "Commodity selected",
      "SelectProducts": "Select materials",
      "SearchProduct": " Search material",
      "Search": "Search",
      "Display": "Display as:",
      "ViewQuality": "Material specifications ",
      "Vessel": "Vessel name",
      "Voyage": "Shipment no",
      "Price(perDMT)": "Base price (per WMT)",
      "Quantity(WMT)": "Quantity",
      "SendBidtoQuote": "Place bid",
      "ClearFilter": "Clear filter",
      "Browseby": "Browse by",
      "Terms&Conditions": "Terms & conditions",
      "ChooseYourOptions": "Choose your options",
      "ConfirmBid?": "Place bid",
      "You": "Please review and confirm your bid",
      "Add": "Add additional binding terms",
      "Your": "Your binding terms here. ",
      "ConfirmBid": "Confirm bid",
      "BacktoProducts": "Back to products",
      "ShowFilter": "Show filter",
      "HideFilter": "Hide filter",
      "Close": "Close",
      "Home": "Home",
      "Ports": "Place of delivery",
      "ProductTypes": "Material Types",
      "Products": "Materials",
      "material": "Material",
      "SelectedPorts": "Ports Selected",
      "SelectedPortstype": "Ports Selected",
      "SelectedTypestypes": "Types Selected",
      "SelectedProductsTypes": "Materials Selected",
      "SelectedTypes": "Types Selected",
      "SelectedProducts": "Materials Selected",
      "validateTime": "Time to validate deal?",
      "bindingTerms": "Other binding terms",
      "bindingTermsPh": "Enter your binding terms here.",
      "validityTime": "Validity time",
      "validityDate": "Validity date",
      "timeZone": "Timezone in Shanghai, China (GMT+8)",
      "selectDate": "Select date",
      "counterOffer": "Counter offer",
      "placeBid": "Place bid",
      "incOfTaxes": "inc. of VAT",
      "hours": "hrs",
      "sortBy": "Sort by",
      "tooltipValue": "Original price is indicative only.",
      "showDetails": "Show details",
      "hideDetails": "Hide details",
      "notAvailable": "Not available",
      "bhpConnect": "BHP Connect",
      "NoItemsFound": "No Items Found",
      "priceisincorrect": "price is incorrect",
      "rmb": "RMB",
      "enterprice": "Please enter your price.",
      "selectQPError":"Please select quotation period.",
      "qtyRequiredCheck":"Please enter Quantity",
      "qtyValidCheck":"Enter Qty between"
    },
    "contracts": {
      "Reset": "Reset",
      "quote": "Quote",
      "products": "Materials",
      "invoice": "Invoice",
      "vessel": "Vessel",
      "voyage": "Voyage No",
      "totalPrice": "Total price",
      "port": "Port",
      "unitPrice": "Unit price",
      "qty": "QTY",
      "faqs": "Digital Gateway FAQs",
      "bhpTeam": "BHP team",
      "usefulLinks": "Useful links",
      "search": "Search",
      "Filterby": "Filter by:",
      "Nomore": "No items found...",
      "ClearFilter": "Clear Filter",
      "dateRange": "Select date period",
      "selectdaterange": "Select Date Range",
      "selectPorts": "Select Place of delivery ",
      "selectProducts": "Select Material",
      "date": "Date",
      "coa": "COA",
      "releaseOrder": "Release Order",
      "paymentInvoice": " Pre/Down Payment Invoice",
      "VATinvoice": " VAT invoice (settlement invoice)",
      "seeResults": "See results",
      "clearFilter": "Clear filter",
      "Noresults": "No results",
      "Search": "Search",
      "SearchID": "Search ID"
    },
    "validation": {
      "Field": "This Field Is Mandatory",
      "valid": "Please Enter a Valid Mobile No.",
      "special": " First Name can not have any special characters",
      "email": "Please provide a valid Email address Ex: User@companyname.com",
      "mobile": "Please Enter a Valid Mobile No.",
      "userIdExist": "UserID Already Exist . Please try with anyother UserID"
    },
    "quote": {
      "BidPlacedBy": "Bid placed by",
      "Submissiondeadline": "Submission deadline:",
      "Expiringin": "Expiring in ",
      "d": "d ",
      "h": "h ",
      "m": "m ",
      "s": "s",
      "M": "M ",
      "Today": "today",
      "Quote#": "Quote #",
      "QuoteDate": "Quote date",
      "currently": "There are no active Bids currently available.",
      "nocurrently": "There are no active Invitation to bids currently available.",
      "Status": "Status",
      "Total": "Total",
      "Validity(GMT +10)": "Validity(GMT +10)",
      "Actions": "Actions",
      "BindingTerms": "Binding terms",
      "Thisis": "This is where you add binding terms.",
      "RequestChange": "Request change",
      "Price (¥)": "Price (¥)",
      "Qty": "Qty",
      "SendforApproval": "Send for approval",
      "Minimumorderquantity": "Minimum order quantity",
      "Active": "Active",
      "Accepted": "Accepted",
      "Vesselname": "Vessel name",
      "Voyage": "Shipment no",
      "Cancelbid": "Cancel bid",
      "Vadilitydate": "Vadility date:",
      "Timezone": "Timezone in Shanghai, China (GMT+8)",
      "Vadilitytime": "Vadility time:",
      "Include": "Include additional binding terms",
      "submit": "Please submit your conter offer",
      "Icancel": "I want to cancel my bid",
      "Ireject": "I want to reject the offer",
      "Iaccept": "I want to accept the offer",
      "Rejectoffer": "Reject offer",
      "Respondtooffer": "Respond to offer",
      "Counteroffer": "Counter offer",
      "Price(perWMT)": "Base Price (per WMT):",
      "Quantity": "Quantity",
      "Quantity(WMT)": "Quantity (WMT) ",
      "Acceptoffer": "Accept offer",
      "Archived": "Archived",
      "Creation": "Creation date:",
      "Otherterms": "Other terms",
      "TermsandConditions": "Terms and Conditions",
      "PaymentTerms": "Payment Terms",
      "Additional": "Other binding terms",
      "AdditionalRemarks": "Your additional remarks",
      "BuyerRemarks": "Buyer remarks",
      "Weare": "We are pleased to forward an offer on behalf of Seller on the terms set out below:",
      "Relevance": "Relevance",
      "Popularity": "Popularity",
      "Low": "Low to High",
      "Print": "Print",
      "Sellername": "Seller name",
      "Exportpdf": "Export PDF",
      "MasteragreementNo": "Master agreement No.",
      "Agreementdate": "Agreement date",
      "High": "High to Low",
      "validity": "Validity : ",
      "Id": "ID: ",
      "BHP": " BHP Billiton Marketing AG",
      "Backtolist": "Back to list",
      "Creationdate": "Creation Date: ",
      "Congratulations": " Congratulations, offer has been accepted",
      "You": "You’ve cancelled ",
      "cancelledBid": "Your bid has been cancelled",
      "rejectBid": "Your bid has been rejected",
      "Viewdetails": "View details ",
      "Close": "Close",
      "Thiscancel": "Are you sure you want to cancel the bid?",
      "Thisreject": "Are you sure you want to reject the offer?",
      "Thisaccept": "Are you sure you want to accept the offer?",
      "Changepassword": "Change password",
      "oldPassword": "Old password",
      "newPassword": "New password",
      "ConfirmnewPassword": "Confirm new password",
      "Security": "For security reasons, you need to change your password:",
      "Upperlower": "Uppercase and a lower case",
      "bidPlacedSuccess": "Your bid has been placed successfully.",
      "Save": "Save",
      "resetPassword": "Set new password",
      "Cancel": "Cancel",
      "NA": "NA",
      "clickOnSave": "By clicking Save, you agree on our ",
      "termsLink": "Terms of use",
      "privacyPolicyLink": "Privacy policy",
      "and": "and",
      "confirm": "Confirm",
      "transactionDetails": "Download transaction details",
      "Transaction": "Transaction details",
      "AcceptTxt": "By clicking on the button below, you confirm that you are not accepting the offer from India region. If you are accepting the offer from India region, any tax implications arising due to this would be borne by you."
    },
    "inventory": {
      "PublishedBatches": "Published Batches",
      "UnpublishedBatches": "Unpublished Batches",
      "ArchivedBatches": "Archived Batches"
    },
    "addressBooks": {
      "company": "Company",
      "shippingAddress": "Shipping address",
      "billingAddress": "Billing address"
    },
    "forgotPassword": {
      "notablechanges": "Notable Changes",
      "accept&continue": "Accept and continue",
      "forgot": " Please enter your email address in the field below.",
      "warrant": "Warrant that you have authority to bind the company that you represent to the",
      "resetEmailSent": "An e-mail with further instructions will be sent for you to reset your password. ",
      "email": "Email address",
      "emailFormat": "Use proper email format, eg.name@company.com",
      "btnResetMail": " Submit",
      "btnToLogin": " Back to login screen",
      "emailPlaceholder": "Enter email address",
      "confirmClick": "By clicking ‘Confirm’, you hereby:",
      "acknowledge": "Acknowledge that you have fully and carefully reviewed the ",
      "termsOfUse": "Terms of Use",
      "buyertermsofUse":"Buyer’s Terms of Use ",
      "buyer":"Buyer’s Terms",
      "applicable":" (applicable to buyers of BHP materials) ",
      "or":"or the",
      "contractor":"Vendor's Terms of Use",
      "applicableContractor":" (applicable to Vendors of BHP), and you understand the contents  and explicitly agree to be bound by the respective Terms of Use;",
      "carefully":"Acknowledge that you have fully and carefully reviewed the ",
      "contents":", and you understand the contents and explicitly agree to be bound by the respective Terms of Use;",
      "understand":"and you understand the contents of the ",
      "explicitly":" explicitly agree to be bound by the Privacy Policy, and expressly and specifically consent that we can collect, use, process, and transmit your personal information according to the  ",
      "matters":"Especially, you hereby give separate consent to: the processing rules outlined in Section 2 regarding “personal information that is necessary to be collected, and the consequences of our inability to provide services if you refuse to provide such information” and “sensitive personal information”; the processing rules outlined in Section 4 regarding “personal information sharing”; and the processing rules outlined in Section 5 regarding “authorizing third parties to process personal information”.",
      "processing":"You confirm that you agree to the processing rules outlined in Section 2 of the",
      "regarding":" regarding “personal information that are is necessary to be collected, and the consequences of our inability to provide services if you refuse to provide such information”;",
      "rules":"You confirm that you agree to the processing rules outlined in Section 2 of the ",
      "personal":"regarding “sensitive personal information”;",
      "section":"You confirm that you agree to the processing rules outlined in Section 4 of regarding “personal information sharing” and Section 5 of the ",
      "parties":"regarding “authorizing third parties to process personal information”.",
      "andThe": "and the",
      "privacypolicy": "Privacy Policy",
      "privacyPolicy": "Privacy Policy",
      "Policy": "",
      "policy": "",
      "accept": "",
      "notable": "",
      "acceptcontinue": "",
      "agreeConcern": "Agree and consent to the  ",
      "consentText": "Expressly and specifically consent that we can collect, use, process, and transmit your personal information according to ",
      "and": "and",
      "an": "and",
      "consent": "",
      "warant": "",
      "privacy": "Privacy Policy.",
      "alternateuse":"Use alternate account ",
      "altemailanotreceived":" (if email not received)",
      "alternateEmailMessage":"Re-enter your email address and select 'use alternate account’ to receive a new password reset email."
    },
    "toastErrorMessages": {
      "addressBook": "Address Book - Something went wrong. Please try again later",
      "dataSaved": "Data saved successfully !!!",
      "something": "Something went wrong. Please try again later",
      "product": "Browse by Product - Something went wrong. Please try again later",
      "port": "Browse by Port - Something went wrong. Please try again later",
      "copy": "Text copied to Clipboard",
      "Uppercaseandalowercase": "Uppercase and a lower case",
      "Minimum": "Minimum 8 characters",
      "Specialcharacter": "Special character",
      "placebidfirst": "Place bid",
      "placebidsecond": "or higher",
      "Uppercaseandalowercase1": "",
      "Minimum1": "",
      "Specialcharacter1": ""
    },
    "loginForm": {
      "emailAddress": {
        "label": "Email address *",
        "placeholder": "Enter email",
        "selectOTPMethod": "Please select your preferred OTP method:",
        "selectOTPMethodDescription": "BHP uses two-factor authentication (2FA) for enhanced security. Please select your preferred method to complete the 2FA and log into BHP Connect.",
        "ChangeMethod": "To change your preferred method, go to your Account Settings."
      },
      "password": {
        "label": "Password *",
        "placeholder": "Password"
      },
      "signIn": "Sign in",
      "forgotPassword": "Forgot password",
      "format": "Use proper email format, eg. name@company.com",
      "sentVerificationCode": "A one-time verification code has been sent to your email.",
      "sentVerificationCodeSMS": "A one-time verification code has been sent to your registered mobile phone.",
      "resendCode": "Re send code by ",
      "digit": "Please enter the 6-digit code to authenticate your sign in.",
      "otpCode": "Verification code",
      "enterCode": "Enter your code",
      "submit": "Submit",
      "invalidCodeProvided": "Invalid code provided.",
      "updatePassword": "Update password",
      "otppage": "Verification code",
      "TroubleSignIn": "Trouble sign in? Contact to your BHP representative to update your contact details.",
      "email": "Email",
      "SMS": "SMS",
      "OTPMandatory": "Please select any 1 OTP method",
      "NotSupportingCountriesLabelBefore":"2FA via SMS available for ",
      "NotSupportingCountriesLabel":" selected countries ",
      "NotSupportingCountriesLabelAfter":" only",
      "SMSCountries":"SMS available countries",
      "SMSCountriesDescription":"If 2FA SMS is not available for your country, please use an alternative method to complete the 2FA. BHP is working to make the functionality available in more countries.",
      "SMSNotAvailableCountries":"Service not available in",
      "Lastupdate": "Last update",
      "resendOtpTimer":"Resend OTP in ",
      "resendOtpBlocked":"Resend OTP will be available in",
      "fingerprint":"Fingerprint",
      "keepLoggedIn": "Keep me logged in",
      "Biometrics": {
        "loginWithPasskey": "Login with passkey",
        "biometricandsecurity":"Biometrics and security",
        "Authmethod": "Authentication methods",
        "UsePasskeyMsg": "Use your passkey to securely access your account",
        "Disablepasskeylogin":"Disable passkey login",
        "confirmMsg":"Do you want to disable face id and login using your username and password instead?",
        "yesdisable":"Yes, disable",
        "enable":"Enable passkey login",
        "doyouwantEnable":"Do you want to enable passkey for a faster login next time?",
        "enableSetting":"You can enable passkey on  in your user settings",
        "yesallow":"Yes, allow",
        "notnow":"No, not now",
        "errorLogin":"Error while logging in with passkey",
        "successLogin":"User is logged in successfully using passkey",
        "errorRegister":"Error registering passkey",
        "missingLogin":"Login details missing, please logout and login again to enable passkey",
        "removesuccess":"Passkey removed successfully",
        "removeError":"Error in removing passkey",
        "errorAdding":"Error while adding passkey",
        "cancel":"Cancel"

      }
      


    },
    "filter": {
      "filters": "Filters",
      "ports": "Place of delivery :",
      "productTypes": "Material Types :",
      "products": "Materials :",
      "commodityType":"Commodity Type :"
    },
    "help": {
      "User": "User Guides",
      "refer": "Please refer to the user guides below to access instructions on how to use and interact with  BHP Connect on mobile devices and desktop computers.",
      "guide": "Mobile App User Guide",
      "desktopguide": "Desktop App User Guide",
      "pleaseClick": " Please click on the",
      "link": "link",
      "toDownload": " to download",
      "faq": "Frequently Asked Questions",
      "returnsAndRefunds": "Returns and refunds",
      "registration": "Registration",
      "yourOnlineAccount": "Your online account",
      "orders": "Orders",
      "promotionsAndDiscounts": "Promotions and discounts",
      "productAndGeneralInformations": "Product and general Informations",
      "storeInformation": "Store information",
      "businessContacts": "Business contacts",
      "buyingGuides": "Buying guides",
      "sizeGuides": "Size guides",
      "privacyAndSecurity": "Privacy and security",
      "backToTop": "back to top",
      "text": "text",
      "status": "Status",
      "description": "Description",
      "note": "Please note:",
      "Information": "Information",
      "pageUnderConstruction": "Page Under Construction - Not Completely Functional",
      "deliveryInfo": {
        "deliveryInformation": "Delivery information",
        "deliveryOptions": "Delivery Options",
        "deliveryTimesCharges": "Delivery times & charges",
        "orderTrackingInformation": "Order tracking information",
        "courierStatusInformation": "Courier status information"
      },
      "deliveryOptions": {
        "paragraph1": "The delivery options available to you are shown in the Checkout area under Delivery Method.",
        "paragraph2": "Based on your deliver address, these options may not all be available:",
        "homeDelivery": "Home Delivery",
        "standardDelivery": "Standard delivery",
        "otherDeliveryMethod": "Other delivery method",
        "internationalDelivery": "International delivery",
        "homeDeliveryDesc": "- Free UK standard delivery on all orders over L50 within 4 working days (*exceptions may apply)",
        "standardDeliveryDesc": "- 1 to 2 business days",
        "otherDeliveryMethodDesc": "- 3 to 5 business days",
        "internationalDeliveryDesc": "- 7 to 10 business days (not all countries are available)"
      },
      "deliveryTimesCharges": {
        "paragraph1": "We deliver the majority of our orders within 4 working days* for L3.99 or FREE on orders over L50 (*exceptions apply, see table below).",
        "list1": "Deliveries to UK addresses are made Monday to Friday between 9am to 6pm, excluding Bank Holidays.",
        "list2": "Deliveries to the Scottish Highlands and Islands, offshore locations and Northern Ireland may take a little longer. For delivery to ROI addresses please visit our Irish website at hybris.com",
        "list3": "Multiple items may be delivered in more than one parcel and at different times."
      },
      "orderTracking": {
        "paragraph1": "We will send you email updates through every stage of your order. In each email your current order's status will be shown. Each order status is explained in the table below. We deliver most parcels via our courier. You can track these parcels by clicking on the parcel reference link on your email. Once you have clicked on the link you will be directed to the courier website. For information on courier statuses please ",
        "clickHere": "click here",
        "processing": "Processing",
        "processingDesc": "Your order is being processed.",
        "despatched": "Despatched",
        "despatchedDesc1": "Your order has been despatched to the courier.",
        "despatchedDesc2": "For heavy and large products your order is ready to be despatched by our carrier. The carrier will contact you to arrange a suitable date for delivery.",
        "despatchedDesc3": "For Collect from store orders you will receive a further order status update when your item(s) are ready to collect (see below for more information on collect from store statuses)",
        "cancelled": "Cancelled",
        "unableToFulfill": "Unable to fulfill",
        "paymentReversal": "payment reversal",
        "paymentReversalDesc": "Your order has been cancelled due to stock availability, no payment has been taken.",
        "paymentRefunded": "Payment refunded",
        "paymentRefundedDesc": "Your order has been cancelled due to stock availability. We have processed a refund to your payment card.",
        "returnReceived": "Return received",
        "returnReceivedDesc": "Your return has been received. However, due to goods being addressed to the incorrect warehouse there may be a short delay in your refund being processes while the goods are being re-directed.",
        "readyForCollection": "Order ready for collection",
        "readyForCollectionDesc": "Your order is ready for collection at your chosen store.",
        "noteDesc": "You must collect your order within 14 days of receiving your notification email.",
        "collected": "Collected",
        "collectedDesc": "Your order has been collected.",
        "returnInProgress": "Return in progress",
        "returnInProgressDesc": "We are processing your return.",
        "returnRefundComplete": "Return refund complete",
        "returnRefundCompleteDesc": "We have processed your return",
        "returnRefundCompleteNote": "Some banks may take longer than others to process refunds."
      },
      "courierStatus": {
        "orderGenerated": "Order generated",
        "orderGeneratedDesc": "Your order is ready for delivery and has entered into the courier system.",
        "receiptAtDepot": "Receipt at depot",
        "receiptAtDepotDesc": "Your parcel has been received at the depot.",
        "processedAtDepot": "Processed at depot",
        "processedAtDepotDesc": "Your parcel has processed through the depot operation and is ready for onward despatch to the courier.",
        "outForDelivery": "Out for delivery to courier",
        "outForDeliveryDesc": "Your parcel has left the depot for delivery to courier.",
        "courierReAttempt": "Courier to re-attempt",
        "courierReAttemptDesc": "The courier has attempted to deliver your parcel and will try again. You will receive a card to confirm delivery has been attempted.",
        "delivered": "Delivered to",
        "deliveredDesc": "Your parcel has been delivered."
      }
    },
    "navigationMenus": {
      "bhpTeam": {
        "displayTitle": "BHP team",
        "description": "View BHP Team details.",
        "updateCount": 6,
        "updateCountText": "Team updates",
        "ctaLink": "Manage team",
        "menuIcon": "/images/Materials.svg",
        "route": "bhpteam",
        "title":"bhpTeam"
      },
      "myCompany": {
        "displayTitle": "My company",
        "description": "View your company details.",
        "updateCount": 3,
        "updateCountText": "Offers updates",
        "ctaLink": "Manage company",
        "menuIcon": "/images/Materials.svg",
        "route": "/companies/myCompany/groupcompanies/detail",
        "subItems":{
          "groupCompanies": "Company details",          
          "contacts": "Contacts"          
        },
        "title":"myCompany"
      },
      "bidsAndOffers": {
        "displayTitle": "Bids & offers",
        "description": "Track your bids, view offers, and manage your bidding activities.",
        "updateCount": 3,
        "updateCountText": "Offers updates",
        "ctaLink": "Manage bids and offers",
        "menuIcon": "/images/Bids and offers.svg",
        "route": "/quotes/myquotes",
        "title":"bidsAndOffers"
      },
       "Orders": {
        "displayTitle": "Orders",
        "description": "Track your Orders, view offers, and manage your bidding activities.",
        "updateCount": 3,
        "updateCountText": "Offers updates",
        "ctaLink": "Manage Orders",
        "menuIcon": "/images/Bids and offers.svg",
        "route": "/quotes/myquotes",
        "title":"Orders"
      },

      "invitationToBid": {
        "displayTitle": "Invitation to bid",
        "description": "Access product negotiations you were invited to participate.",
        "updateCount": 5,
        "updateCountText": "New invitations",
        "ctaLink": "Explore products",
        "menuIcon": "/images/Invitation to bid.svg",
        "route": "opentenders",
        "title":"invitationToBid"
      },
      "materials": {
        "displayTitle": "Materials",
        "description": "Browse BHP materials and place bids to start a negotiation.",
        "updateCount": 15,
        "updateCountText": "New materials added",
        "ctaLink": "View materials",
        "menuIcon": "/images/Materials.svg",
        "route": "products",
        "title":"materials"
      },
      "helpAndSupport": {
        "displayTitle": "Help & support",
        "description": "Find answers to your questions, access support articles, and get assistance from our team.",
        "updateCount": 2,
        "updateCountText": "New FAQs added",
        "ctaLink": "Get help & support",
        "menuIcon": "/images/Helps and support.svg",
        "route": "help",
        "title":"helpAndSupport"
      },
      "shipsAndDocs": {
        "displayTitle": "Ships & docs",
        "description": "Monitor shipping statuses, access documents, and be updated.",
        "updateCount": 10,
        "updateCountText": "New documents uploads",
        "ctaLink": "View shipments & documents",
        "menuIcon": "/images/Ships and docs.svg",
        "route": "shipment",
        "title":"shipsAndDocs",
        "subItems":{
          "shipsAndDocsCons": "Consignment",          
          "shipsAndDocsRail": "Rail",
          "Vessels": "Vessels"          
        }
      },
      "consignment": {
        "displayTitle": "Consignment",
        "description": "Browse BHP materials and offer to strat a negotiation.",
        "updateCount": 10,
        "updateCountText": "Text to be finalised",
        "ctaLink": "View materials and offer",
        "menuIcon": "/images/warehouse.svg",
        "route": "consignment",
        "title":"consignment"
      },
      
     
      "ctContracts": {
        "displayTitle": "Contracts",
        "description": "View and manage contract terms related to BHP materials",
        "updateCount": 10,
        "updateCountText": "Text to be finalised",
        "ctaLink": "View Contracts",
        "menuIcon": "/images/contracts.svg",
        "route": "mycontracts",
        "title":"ctcontracts"
      },
       "batches": {
        "displayTitle": "Batches",
        "description": "Track you batches",
        "updateCount": 10,
        "updateCountText": "Text to be finalised",
        "ctaLink": "View batches",
        "menuIcon": "/images/truck.svg",
        "route": "/",
         "subItems":{
          "portside":{
            "title": "Portside",
            "items":{
              "delivery":{
                "displayTitle": "Delivery",
                "route":"/batches",
                "description": "View batches delivery records",
                "ctaLink": "View batches and records"
              } ,
              "screening": {
                "displayTitle": "Screening",
                "route":"/dvl-screening-list/dvl-screening-list/portside",
                "menuIcon": "/images/portsidescreening.svg",
                "description": "Access screening batches to assess quality and readiness.",
                "ctaLink": "Review screening details"
              },
              "qualityInspection": {
                "displayTitle": "Quality",
                "route":"/shipmentvms/quality-inspection",
                "menuIcon": "/images/batches-quality.svg",
                "description": "Monitor batch quality assessments to ensure material readiness and compliance.",
                "ctaLink": "Review quality reports"

              }
          } 
        },
          "bondedwarehouse": {
            "title": "Bonded warehouse",
            "items":{
              "screening": {
                "displayTitle": "Screening",
                "route":"/dvl-screening-list/dvl-screening-list/bondedwarehouse",
                "menuIcon": "/images/screeningbw.svg",
                "description": "Access screening batches to assess quality and readiness.",
                "ctaLink": "Review bonded warehouse screening reports"
              }              
            }
          }            
        }
      },
      
      "shipment":{
        "displayTitle": "Shipments",
        "description": "Track your shipment data",
        "updateCount": 10,
        "updateCountText": "Text to be finalised",
        "ctaLink": "View shipment data",
        "menuIcon": "/images/Ships and docs.svg",
        "route": "/",
        "subItems":{
          "portside":{
            "title": "Portside",
            "items":{
              "arrivals":{
                "displayTitle": "Arrivals",
                "route":"shipmentvms/shipmentvmslist/portside",
                "description": "Browse BHP shipment records and track the expected arrival times of materials.",
                "ctaLink": "Track arrivals",
                 "menuIcon": "/images/arrivalsportside.svg"
              } ,
              "inspection": {
                "displayTitle": "Inspection",
                "route":"/shipmentinspection/shipmentinspectionlist/portside",
                "menuIcon": "/images/inspection.svg",
                "description": "Review inspection reports, and compliance details for incoming BHP shipments.",
                "ctaLink": "View inspection details"
              }
            }
          } ,
          "bondedwarehouse": {
            "title": "Bonded warehouse",
            "items":{
              "arrivals": {
                "displayTitle": "Arrivals",
                "route":"shipmentvms/shipmentvmslist/bondedwarehouse",
                "description": "Browse BHP shipment records and track the expected arrival times of materials.",
                "ctaLink": "Track bonded warehouse arrivals",
                 "menuIcon": "/images/arrivalsbw.svg"
              },
              "inspection": {
                "displayTitle": "Inspection",
                "route":"/shipmentinspection/shipmentinspectionlist/bondedwarehouse",
                "menuIcon": "/images/inspectionbw.svg",
                "description": "Review inspection reports, and compliance details for incoming BHP shipments.",
                "ctaLink": "View bonded warehouse inspection details"
              }
            }
          }            
        }
      }, 
      "bilateral": {
        "displayTitle": "Bilateral-Cargos",
        "description": "Browse available BHP materials, review terms and start bilateral bid negotiations",
        "updateCount": 5,
        "updateCountText": "New invitations",
        "ctaLink": "View materials",
        "menuIcon": "/images/bilateral-cargo.svg",
        "route": "bilateralCargos",
        "title":"bilateral"
      }
    },
    "vms":{
      "back":"Back to list",
      "lastDelDate":"Last Delivery Date",
      "noPickUp":"No pick up",
      "customer":"Customer",
      "actualQty":"Actual quantity",
      "totalDel":"Total Delivery",
      "ramainingInv":"Remaining Inventory",
      "delCompleted":"Delivery completed",
      "recDel":"Record Delivery",
      "inProgress":"In Progress",
      "new":"New",
      "assigned":"Assigned",
      "dischargePort":"Discharge Port",
      "material":"Material",
      "blQty":"BL Quantity",
      "batchComp":"Batch Completed",
      "Quantity":"Quantity",
      "Delivered":"Delivered inventory",
      "noNominations":"No Nomination to display"
   },
   "recordpickup":{
      "recordDelivery":"Record delivery",
      "deliveryQuantity":"Delivery Quantity",
      "deliveryDate":"Delivery Date",
      "deliveryMode":"Mode",
      "addDelivery":"Add delivery",
      "remarks":"Remarks",
      "deliveryCompleted":"Delivery Completed",
      "yes":"YES",
      "no":"NO",
      "selectFile":"Select File",
      "save":"Save",
      "cancel":"Cancel",
      "selectFileLongText":"Select a file or drag and drop here*",
      "fileSizeText":"File size no more than 10 MB",
      "uploadFileText":"Upload file",
      "uploadFileBelowText":"Before marking this as completed attach a file",
      "emptySaveerr":"Please add alteast one delivery.",
      "preview":"Preview",
      "deliveryQuantityErrmsg":"Delivery quantity is required.",
      "deliveryDateErrmsg":"Delivery date is required.",
      "ModeErrmsg": "Mode is required.",
      "totalDelivery": "Total Delivery",
      "saveChanges": "Save your changes to trigger validation and review information",
      "validate": "Validate",
      "reValidate": "Re-Validate",
      "createInvoice": "Create Invoice",
      "onceSaved": "Once saved, Changes cannot be reversed. Ensure all entries and attached files have been validated. Select save to confirm and proceed",
      "totalDeliveryDiff": "Total delivery quantity differs from scheduled quantity by 10% or more.",
      "dataSubmitted": "The data has been successfully submitted and is currently under validation, please try to reload after some time to see the validation results using the reload button next to the validation status.",
      "validationResults": "Validation  results and any error details will appear here.",
      "pleaseConfirmComplete": "Please confirm before declare as complete",
      "stockAdjustment":"Stock adjustment",
      "AzureNotValidated": "Not yet validated",
      "AzureUnsuccessfulValidation": "Unsuccessful validation",
      "AzureValidatedSuccessfully": "Validated successfully",
      "AzureValidating": "Validating...",
      "AzurePartialSuccess": "Partial success",
      "PleaseConfirmStock": "Please confirm before stock adjustment ",
      "Reload":"Reload",
      "confirm":"Confirm",
      "confirmCompletion":"Confirm Completion"
   }
  }
}


